import React from "react";
import css from "./CircularProgressBar.module.scss";
import Tooltip from '@mui/material/Tooltip';
const CircularProgressBar = ({ progress, size = 150, strokeWidth = 10, color = "#4F1382" ,children}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;



  return (
    <div className={css.progress_container} style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        {/* Background Circle */}
        <circle
          className={css.background_circle}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          style={{ strokeWidth }}
        />
        {/* Progress Circle */}
        <Tooltip title ={`progress ${progress}%`} placement="top">
        <circle
          className={css.progress_circle}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          style={{
            stroke: color,
            strokeWidth,
            strokeDasharray: circumference,
            strokeDashoffset: offset,
          }}
        />
        </Tooltip>
      </svg>
      <div className={css.progress_label}>{children}</div>
    </div>
  );
};

export default CircularProgressBar;
